import {
  CHANGE_MESSAGE_STEP_PROPERTY,
  GET_DEFAULT_TRAINING_DATA_ASYNC,
  VALIDATE_MESSAGE_STEP_FIELDS,
} from '../../WizardTrainingCampaign/constants'

import { DATA_HAS_CHANGED, GET_EMAIL_PREVIEW_ASYNC } from './constants'

const changeMessageProperty = (value, propertyName) => ({
  type: CHANGE_MESSAGE_STEP_PROPERTY,
  payload: { value, propertyName },
})

export const validateMessageStep = () => ({
  type: VALIDATE_MESSAGE_STEP_FIELDS,
})

export const getDefaultTrainingData = (data) => ({
  type: GET_DEFAULT_TRAINING_DATA_ASYNC.INITIATE,
  payload: { data },
})

export const getDefaultTrainingDataSuccess = (data) => ({
  type: GET_DEFAULT_TRAINING_DATA_ASYNC.SUCCESS,
  payload: { data },
})

export const getDefaultTrainingDataError = (error) => ({
  type: GET_DEFAULT_TRAINING_DATA_ASYNC.ERROR,
  error,
})

export const getEmailPreview = (data) => ({
  type: GET_EMAIL_PREVIEW_ASYNC.INITIATE,
  payload: { data },
})

export const getEmailPreviewSuccess = (data) => ({
  type: GET_EMAIL_PREVIEW_ASYNC.SUCCESS,
  payload: { data },
})

export const getEmailPreviewError = (error) => ({
  type: GET_EMAIL_PREVIEW_ASYNC.ERROR,
  payload: { error },
})

export const toggleDataHasChanged = () => ({ type: DATA_HAS_CHANGED })

export default {
  changeMessageProperty,
  validateMessageStep,
  getDefaultTrainingData,
  getEmailPreview,
  toggleDataHasChanged,
}
